import React from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

interface EditNotesDialogProps {
  visible: boolean;
  onHide: () => void;
  notes: string;
  onNotesChange: (value: string) => void;
  onApprove: () => void;
  loading: boolean;
}

export const EditNotesDialog: React.FC<EditNotesDialogProps> = ({
  visible,
  onHide,
  notes,
  onNotesChange,
  onApprove,
  loading,
}) => {
  return (
    <Dialog
      header="עריכת הערות"
      visible={visible}
      style={{ width: '500px', direction: 'rtl' }}
      onHide={onHide}
      modal
    >
      <div style={{ padding: '20px 0' }}>
        <label
          htmlFor="notes"
          style={{ display: 'block', marginBottom: '8px' }}
        >
          הערות (עד 350 תווים):
        </label>
        <InputTextarea
          id="notes"
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          maxLength={350}
          rows={6}
          style={{ width: '100%', resize: 'vertical' }}
          placeholder="הזן הערות"
        />
        <div style={{ marginTop: '4px', fontSize: '12px', color: '#6A6A6A' }}>
          {notes.length} / 350 תווים
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <Button
          label="ביטול"
          onClick={onHide}
          className="p-button-text"
          disabled={loading}
        />
        <Button label="אישור" onClick={onApprove} loading={loading} />
      </div>
    </Dialog>
  );
};
